import {
  getChaptersByLanguage,
  getChapterById,
  getChapterByNumber,
  getSlokasByLanguage,
  getSlokaById,
  getSlokasByChapter,
  getSlokasBySpeaker,
  getSpeakers,
  getSpeakerStats,
  getChapterSpeakerStats,
  getCommentariesBySloka,
  getSynonymsByChapter,
  getMbhData
} from './dataService';
import { DEFAULT_LANGUAGE } from '../utils/defaultLanguage';

function getErrorMessage(error) {
  if (error?.message) return error.message;
  return 'Something went wrong. Please try again.';
}

export async function fetchChapters(language = DEFAULT_LANGUAGE) {
  return getChaptersByLanguage(language);
}

export async function fetchChapterById(id) {
  const chapter = await getChapterById(id);
  if (!chapter) throw new Error('Chapter not found');
  return chapter;
}

export async function fetchChapterByNumber(language, chapterNumber) {
  const chapter = await getChapterByNumber(language, chapterNumber);
  if (!chapter) throw new Error('Chapter not found');
  return chapter;
}

export async function fetchSlokas() {
  return getSlokasByLanguage(DEFAULT_LANGUAGE);
}

export async function fetchSlokasByLanguage(language = DEFAULT_LANGUAGE) {
  return getSlokasByLanguage(language);
}

export async function fetchSlokaById(id) {
  const sloka = await getSlokaById(id);
  if (!sloka) throw new Error('Sloka not found');
  return sloka;
}

export async function fetchSlokasByChapter(language, chapterNumber) {
  return getSlokasByChapter(language, chapterNumber);
}

export async function fetchSlokasBySpeaker(speaker, language = DEFAULT_LANGUAGE, chapterNumber) {
  return getSlokasBySpeaker(language, speaker, chapterNumber);
}

export async function fetchSpeakers() {
  return getSpeakers();
}

export async function fetchSpeakerStats() {
  return getSpeakerStats();
}

export async function fetchChapterSpeakerStats() {
  return getChapterSpeakerStats();
}

export async function fetchCommentariesBySloka(language, chapterNumber, slokaNumber) {
  return getCommentariesBySloka(language, chapterNumber, slokaNumber);
}

export async function fetchSynonymsByChapter(language, chapterNumber) {
  return getSynonymsByChapter(language, chapterNumber);
}

export async function fetchMbhData() {
  return getMbhData();
}

export { getErrorMessage };
